import * as React from 'react';
import { Link } from 'react-router-dom';

import { DASHBOARD_RECALCULATION } from 'src/app/constants/route';
import { toCountFormat, toPercentageFormat } from './Dashboard.formatters';
import { DashboardTimelinessBucket } from './Dashboard.queries';

interface TimelinessCardProps {
  buckets: DashboardTimelinessBucket[];
  uncalculatedOrders: number;
}

const BUCKET_MODIFIERS = ['ontime', 'oneday', 'twodays', 'late'];

export const TimelinessCard = (props: TimelinessCardProps) => {
  const { buckets, uncalculatedOrders } = props;
  const hasData = buckets.some((bucket: DashboardTimelinessBucket) => bucket.count > 0);

  return (
    <div className="Dashboard__card Dashboard__stat-card Dashboard__timeliness">
      <div className="Dashboard__stat-card-header">
        <span className="Dashboard__stat-icon Dashboard__stat-icon--orange">🚚</span>
        <span className="Dashboard__stat-label">Delivery Timeliness</span>
      </div>

      {/*
        Only the last year is materialised. Older months read as empty until someone recalculates
        them, so say that explicitly rather than letting the card imply nothing was delivered.
      */}
      {uncalculatedOrders > 0 && (
        <div className="Dashboard__notice">
          {toCountFormat(uncalculatedOrders)} orders have no timeliness calculated yet.{' '}
          <Link to={DASHBOARD_RECALCULATION.path}>Recalculate this month →</Link>
        </div>
      )}

      {!hasData && uncalculatedOrders === 0 && (
        <div className="Dashboard__empty-inline">No completed orders in this period</div>
      )}

      {hasData &&
        buckets.map((bucket: DashboardTimelinessBucket, index: number) => (
          <div className="Dashboard__timeliness-row" key={bucket.label}>
            <span className="Dashboard__timeliness-label">{bucket.label}</span>
            <span className="Dashboard__timeliness-track">
              <span
                className={`Dashboard__timeliness-fill Dashboard__timeliness-fill--${BUCKET_MODIFIERS[index]}`}
                style={{ width: `${bucket.percentage}%` }}
                title={`${toCountFormat(bucket.count)} order`}
              />
            </span>
            <span className="Dashboard__timeliness-value">{toPercentageFormat(bucket.percentage)}</span>
          </div>
        ))}
    </div>
  );
};
